var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExtensionOffFill = function SvgExtensionOffFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21q-.824 0-1.413-.587A1.93 1.93 0 0 1 3 19v-3.8q1.2 0 2.1-.762.9-.763.9-1.938t-.9-1.937A3.15 3.15 0 0 0 3 9.8V6q0-.425.15-.787t.425-.638l15.85 15.85a1.9 1.9 0 0 1-.637.425Q18.425 21 18 21h-3.8q0-1.2-.762-2.1-.763-.9-1.938-.9t-1.938.9A3.15 3.15 0 0 0 8.8 21zm15-3.85L6.85 4H9q0-1.05.725-1.775T11.5 1.5t1.775.725T14 4h4q.824 0 1.413.588Q20 5.175 20 6v4q1.05 0 1.775.725T22.5 12.5t-.725 1.775T20 15zm-.925 4.75-17-16.975a.93.93 0 0 1-.288-.712A1.02 1.02 0 0 1 2.1 3.5q.3-.3.712-.3.413 0 .713.3l16.975 17q.3.3.3.7t-.3.7-.712.3a.97.97 0 0 1-.713-.3"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExtensionOffFill);
export { ForwardRef as ReactComponent };